import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "message" }, "Title", -1)
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "message" }, "Message", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PDialog = _resolveComponent("PDialog")!

  return (_openBlock(), _createBlock(_component_PDialog, _mergeProps({
    modal: true,
    class: "p-fluid",
    onShow: _ctx.onShow,
    draggable: true,
    keepInViewPort: true,
    minX: 0,
    minY: 0,
    header: _ctx.$t('shift.kpi.message_' + _ctx.action)
  }, _ctx.$attrs, { style: {width: '265px'} }), {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Cancel",
        class: "p-button-info",
        icon: "pi pi-times",
        disabled: _ctx.requestPending,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:visible', false)))
      }, null, 8, ["disabled"]),
      _createVNode(_component_Button, {
        label: "Send",
        icon: "pi pi-send",
        disabled: _ctx.requestPending,
        onClick: _ctx.onSend
      }, null, 8, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_InputText, {
          id: "subject",
          disabled: true,
          modelValue: _ctx.subject,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.subject = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Textarea, {
          id: "message",
          modelValue: _ctx.text,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.text = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 16, ["onShow", "header"]))
}